/** @format */

import React, { useState } from 'react'
import { useAsync, useUpdateEffect } from 'react-use'
import { Cascader } from 'kpc-react'
import { request } from 'src/utils'
import Api from 'src/api/ApiCommon'
import { isNumber } from 'lodash'

export const treeFindPath = (tree, value) => {
  const toFlatArray = (tree, parentId = undefined) => {
    return tree.reduce((t, _) => {
      const child = _.children
      return [
        ...t,
        parentId ? { ..._, parentId } : _,
        ...(child && child.length ? toFlatArray(child, _.pType) : [])
      ]
    }, [])
  }
  const getIds = flatArray => {
    let ids = [value]
    let child = flatArray.find(_ => _.pType === value)
    while (child && child.parentId) {
      ids = [child.parentId, ...ids]
      // eslint-disable-next-line no-loop-func
      child = flatArray.find(_ => _.pType === child.parentId)
    }
    return ids
  }
  return getIds(toFlatArray(tree))
}

const ProductGroupSelect: React.FC<any> = ({ onChange, productList, ...props }) => {
  const [values, setValues] = useState<number[]>()

  const { value: options, loading } = useAsync(async () => {
    if (productList?.length) {
      return productList
    } else {
      const result = await request(Api.getProudctGroup, {})
      if (result.code === 'Success') {
        return result?.data?.categories || []
      }
      return []
    }
  }, [productList])

  useUpdateEffect(() => {
    if (isNumber(props.value)) {
      const v = treeFindPath(options, props.value)
      setValues(v)
    }
  }, [options])

  const renderOptions = (opts: any[]) => {
    return opts?.map(({ pType, name, children }) => {
      return {
        label: name,
        value: pType,
        children: children?.length ? renderOptions(children) : undefined
      }
    })
  }

  return options ? (
    <Cascader
      {...props}
      loading={loading}
      value={values}
      filterable
      data={renderOptions(options)}
      filter={(keyword, props) => {
        return props.label?.toLocaleUpperCase().indexOf(keyword.toLocaleUpperCase()) >= 0
      }}
      on$change-value={(_, value) => {
        setValues(value)
        onChange && onChange(value[value.length - 1])
      }}
    />
  ) : null
}

export default ProductGroupSelect
